import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { IResortShortReport } from 'api/region/types';
import { Routes } from 'routes';
import TitleCell from 'components/common/Grid/Cells/TitleCell';
import ClosingDateCell from 'components/common/Grid/Cells/ClosingDateCell';
import SnowfallCell from 'components/common/Grid/Cells/SnowfallCell';
import BaseDepthCell from 'components/common/Grid/Cells/BaseDepthCell';
import OpenTrailsCell from 'components/common/Grid/Cells/OpenTrailsCell';
import gridHeaderStyles from 'components/common/Grid/styles.module.scss';
import { OpenFlag } from 'api/resort/types';

export const createProjectedClosingGridColumns = () => {
  const { t } = useOTSTranslation('common');

  return [
    {
      header: {
        className: gridHeaderStyles.firstColumn,
        isSortable: true,
        columnName: t('region.liftTickets.resort'),
      },
      dataKey: 'title',
      cellRender: (resort: IResortShortReport) => (
        <TitleCell
          title={resort.title}
          href={Routes.resortSnowReport(resort)}
          updatedDate={resort.status.openFlag !== OpenFlag.NoReportAvailable ? resort.updatedAt : undefined}
        />
      ),
    },
    {
      header: { columnName: t('region.closingDates.projectedDate'), isSortable: true },
      dataKey: 'closing-date',
      cellRender: (row: IResortShortReport) => (
        <ClosingDateCell
          openFlag={row.status.openFlag}
          closingDate={row.status.closingDate}
          noValue={t('common.dash')}
        />
      ),
    },
    {
      header: { columnName: t('region.skiReport.snowfall'), isSortable: true },
      dataKey: 'last-snow',
      cellRender: (row: IResortShortReport) => (
        <SnowfallCell
          openFlag={row.status.openFlag}
          currentWeather={row.snow}
          noValue={t('common.dash')}
        />
      ),
    },
    {
      header: { columnName: t('region.skiReport.baseDepth'), isSortable: true },
      dataKey: 'snow-base',
      cellRender: (row: IResortShortReport) => (
        <BaseDepthCell
          openFlag={row.status.openFlag}
          snow={row.snow}
          surfaceType={row.surfaceType}
          noValue={t('common.dash')}
        />
      ),
    },
    {
      header: { columnName: t('region.skiReport.openTrails'), isSortable: true },
      dataKey: 'runs-open',
      cellRender: (row: IResortShortReport) => (
        <OpenTrailsCell
          openFlag={row.status.openFlag}
          kilometres={row.km}
          runs={row.runs}
          noValue={t('common.dash')}
        />
      ),
    },
  ];
};
